export enum NotificationFlagsEnums {
  INITIAL = 0,
  ACCEPTED = 1,
  REJECTED = 2,
  FORWARDED = 3,
  CANCELLED = 4,
}
